export default __webpack_public_path__ + "static/media/bolas.f93110ab.svg";